import React from "react";
import styled from "styled-components";
import { FaGithub, FaLinkedin, FaTwitter } from "react-icons/fa";

const FooterWrapper = styled.footer`
  background: radial-gradient(circle at top left, #0b0617, #000);
  color: #bbb;
  padding: 2.5rem 1rem;
  text-align: center;
  font-size: 0.95rem;
  border-top: 1px solid rgba(155, 92, 255, 0.15);
  position: relative;
  overflow: hidden;
`;

const Glow = styled.div`
  position: absolute;
  top: -50px;
  left: 50%;
  width: 200px;
  height: 200px;
  background: radial-gradient(circle, rgba(155, 92, 255, 0.3), transparent 70%);
  filter: blur(50px);
  transform: translateX(-50%);
  z-index: 0;
`;

const Content = styled.div`
  position: relative;
  z-index: 1;
`;

const Highlight = styled.span`
  color: #a855f7;
  font-weight: 600;
  transition: 0.3s ease;

  &:hover {
    color: #c59fff;
    text-shadow: 0 0 10px rgba(168, 85, 247, 0.7);
  }
`;

const SocialIcons = styled.div`
  display: flex;
  justify-content: center;
  gap: 18px;
  margin-top: 1rem;

  a {
    color: #bbb;
    font-size: 1.3rem;
    transition: 0.3s ease;

    &:hover {
      color: #a855f7;
      transform: translateY(-3px);
      text-shadow: 0 0 10px rgba(155, 92, 255, 0.7);
    }
  }
`;

const Divider = styled.div`
  width: 80%;
  height: 1px;
  background: rgba(255, 255, 255, 0.08);
  margin: 1.5rem auto;
`;

export default function Footer() {
  return (
    <FooterWrapper>
      <Glow />
      <Content>
        {/* <Divider /> */}
        <p>
          🚀 Built with ❤️ by <Highlight>Engineer Codewala</Highlight>
        </p>

        <SocialIcons>
          <a
            href="https://github.com/engineercodewala"
            target="_blank"
            rel="noreferrer"
          >
            <FaGithub />
          </a>
          <a
            href="https://linkedin.com/company/engineercodewala"
            target="_blank"
            rel="noreferrer"
          >
            <FaLinkedin />
          </a>
          <a
            href="https://twitter.com/engineercodewala"
            target="_blank"
            rel="noreferrer"
          >
            <FaTwitter />
          </a>
        </SocialIcons>
        <p style={{ marginTop: "1rem", fontSize: "0.8rem", color: "#888" }}>
          © {new Date().getFullYear()} SolveMyCodeIssue.com — All Rights
          Reserved
        </p>
      </Content>
    </FooterWrapper>
  );
}
